import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { stopTrack } from '../../store/AudioPlayer/actions';
import Track from '../Tracks/Track/HistoryTrack';

const ClipHistory = ({ clipId, stopTrack }) => {
    const [adsHistory, setAdsHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (clipId) {
            loadHistory();
        }
        return () => stopTrack();
    }, [clipId]);

    const loadHistory = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get("/clip/relative", { params: { id: clipId } });
            if (response.data?.success) {
                setAdsHistory(response.data.success);
            } else {
                setError(response.data?.error || 'Ошибка загрузки истории');
            }
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Загрузка истории...</div>;
    }

    if (error) {
        return <div style={{ color: 'red' }}>{error}</div>;
    }

    if (!adsHistory.length) {
        return <div>История изменений отсутствует</div>;
    }

    return (
        <div className='TrackHistory'>
            {adsHistory.map((el, index) => (
                <div key={el.id}>
                    <Track {...el}
                        first={!index}
                        variant={(index % 2 == 0) ? "gray" : ""}
                    />
                </div>
            ))}
        </div>
    );
};

const mapDispatchToProps = {
    stopTrack
};

export default connect(null, mapDispatchToProps)(ClipHistory);
